@if (!(leagues?.length > 0)) {
  <div class="p-2">
    <app-info-text text="LINKED_PLAYER_LEAGUES_MSG" color="text-gray-400"/>
  </div>
}
<div class="py-1">
  <p-button [label]="('ADD_LEAGUE' | translate) + '...'"
            styleClass="p-button-text" icon="pi pi-plus" (click)="linkLeague()"/>
</div>

<div class="pb-2">
  <p-divider styleClass="divider-nomargin"/>
</div>

<app-loading [active]="isLoading"/>
<app-message [active]="!!errorMsg" [message]="errorMsg"/>

@if (!isLoading) {
  @if (leagues?.length > 0) {
    <app-generic-list class="frontend smart" [frontend]="true"
                      [data]="leagues"
                      [columns]="columns" [columnsMobile]="columnsMobile"
                      [scrollable]="false" [selectionMode]="undefined"
                      [mobileRowTemplate]="mobileRowTemplate"
                      [rowEdit]="false"
                      [dataLoading]="listLoading"
                      [rowDelete]="true" (onRowDelete)="removeLeague($event)"
                      [sortable]="true" [sortOrder]="1" [sortField]="'event.name'"
    />
  } @else {
    <p>
      {{ 'NO_LEAGUES_LINKS_YET' | translate }}
    </p>
  }
}

<ng-template #mobileRowTemplate let-item="data" pTemplate="item">
  <td>
    <div class="flex align-items-center gap-1">
      <ng-container [ngTemplateOutlet]="leagueLinkTemplate" [ngTemplateOutletContext]="{data: item}"/>
      <div class="flex-1 pr-2">
        <div class="flex align-items-center gap-2 text-gray-400">
          <div class="flex-1">
            {{item.event?.name}}
          </div>
          @if (item.event?.seasonName) {
            <div>
              {{ item.event.seasonName }}
            </div>
          }
        </div>
        <div class="pt-1">
          {{item.participantName}}
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="calendarSyncTemplate" [ngTemplateOutletContext]="{data: item}"/>
    </div>
  </td>
</ng-template>

<ng-template #calendarSyncTemplate let-item="data" pTemplate="item">
  <div class="cursor-pointer text-center" (click)="calendarSyncClicked(item)">
    <i class="pi pi-sync hover-element"
       [class.text-green]="item.calendarSync"
       [class.frontend-text-gray]="!item.calendarSync"></i>
  </div>
</ng-template>

<ng-template #leagueLinkTemplate let-item="data" pTemplate="item">
  <div class="text-center">
    <p-button (click)="openLeague(item)" styleClass="p-button-text" icon="pi pi-external-link" size="large"/>
  </div>
</ng-template>
